import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: false,
	styleUrl: './app.component.scss'
})
export class AppComponent {
	title = 'frontend';

	constructor(
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer,
		private translate: TranslateService,
	) {
		const icons = ['area', 'building', 'line', 'person', 'situation', 'unit', 'vehicle', 'feu', 'thw', 'dwd_warnings', 'structural', 'other', 'schadenskonto', 'fuehrung','draw', 'thw_MHP'];
		icons.forEach(name => {
			this.iconRegistry.addSvgIcon(
				'btn_' + name,
				this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`)
			);
		});
		translate.setDefaultLang('de');
		translate.use('de');

	}

}
